const manuscriptEndorsementFormType = {
    ENDORSEMENT_FORM : 1,

    POLICY_FORM : 2

};

angular.module('gw-um-j2js')
    .constant('manuscriptEndorsementFormType', manuscriptEndorsementFormType);